import { render, staticRenderFns } from "./Movieandtvsidescroll.vue?vue&type=template&id=7542dcca&"
import script from "./Movieandtvsidescroll.vue?vue&type=script&lang=js&"
export * from "./Movieandtvsidescroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports